module.exports = __webpack_public_path__ + "static/img/success12.e5365142.png";